import React, { useEffect, useState, useRef } from 'react'
import { useNavigate, Link, NavLink } from 'react-router-dom'
import ReactToPrint, { PrintContextConsumer } from "react-to-print";
import Modal from 'react-modal';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone, faSignIn, faUser } from '@fortawesome/free-solid-svg-icons'
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import '../Home.css';
// import logo from '../images/logo-purple.png'
import logo from '../images/logotime.png'
import axios from 'axios'
import BACKEND_URL from '../api'
import { useCountry } from '../context/CountryContext'

const phoneicon = <FontAwesomeIcon icon={faPhone} />
const usericon = <FontAwesomeIcon icon={faSignIn} />
const regicon = <FontAwesomeIcon icon={faUser} />
const whatsappicon = <FontAwesomeIcon icon={faWhatsapp} />

const topheader = {
  background: "#000000"
}

export default function HeaderElement() {
  const currentUrl = window.location.href;
  const userid = sessionStorage.getItem('userid')
  const ref = useRef();

  // Get country-specific data
  const { selectedCountry, phone, whatsapp, logoUrl, currency } = useCountry();
  
  // Get country prefix for URLs
  const getCountryPrefix = () => {
    if (selectedCountry && selectedCountry.portalUrl) {
      const portalBase = 'https://parcels.shypv.com';
      const suffix = selectedCountry.portalUrl.replace(portalBase, '').replace('/', '');
      return suffix ? `/${suffix}` : '';
    }
    return '';
  };
  
  const countryPrefix = getCountryPrefix();

  const [showReward, setShowReward] = useState(false)
  const [rewardAmount, setRewardAmount] = useState(0)
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [isAnimating, setIsAnimating] = useState(false)
  const [hasNewReward, setHasNewReward] = useState(true)
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  // Pulse animation effect
  useEffect(() => {
    const interval = setInterval(() => {
      if (hasNewReward) {
        setIsAnimating(true)
        setTimeout(() => setIsAnimating(false), 1000)
      }
    }, 3000)

    return () => clearInterval(interval)
  }, [hasNewReward])

  const handleRewardClick = () => {
    // Generate random reward between 10 and 500

    axios.post(`${BACKEND_URL}/getReward`, {
      userid: userid
    }, {})
      .then((res) => {
        console.log("getReward------------", res.data)
        setRewardAmount(res.data.reward_number / 10)
        setName(res.data.user_login)
        setEmail(res.data.user_email)
      })
      .catch((err) => console.log(err))

    setShowReward(true)
    setHasNewReward(false)
  }

  const claimReward = () => {
    if (rewardAmount != 0) {
      setModalIsOpen(true)
    }
    setShowReward(false)
    // Reset the new reward notification after a delay
    setTimeout(() => setHasNewReward(true), 5000)
  }

  const closeReward = () => {
    setShowReward(false)
    // Reset the new reward notification after a delay
    setTimeout(() => setHasNewReward(true), 5000)
  }

  let role = sessionStorage.getItem('userid')
  const navigate = useNavigate()
  function logout() {
    sessionStorage.removeItem('userid');
    sessionStorage.removeItem('is_corporate');
    sessionStorage.removeItem('batch_id');
    alert("user logged out successfully");
    navigate('/login')
  }

  const message_banner = `${BACKEND_URL}/messageBanner`;
  const [message, setMessage] = useState('');
  const [typeban, setTypeban] = useState('');
  useEffect(() => {
    axios
      .get(message_banner)
      .then((response) => {
        setMessage(response.data.message);
        setTypeban(response.data.type);
      })
  }, [])

  const setModalIsOpenToFalse = () => {
    setModalIsOpen(false)
    setSuccessMessage("")
  }

  const handleReward = () => {
    axios.post(`${BACKEND_URL}/handleReward`, {
      userid: userid
    }, {})
      .then((res) => {
        console.log("handleReward--------", res.data)
        if (res.data.sent == true) {
          setSuccessMessage("Email has been sent successfully. Please check.")
        }
      })
      .catch((err) => console.log(err))
  }

  return (
    <>

      <div className="top_header" style={topheader}>
        {
          userid &&
          <>
            <Modal isOpen={modalIsOpen} ariaHideApp={false}>
              <button onClick={setModalIsOpenToFalse} style={{ float: "right" }}>x</button>
              <>

                <div className="container">
                  <div className="row">
                    <div className="col-md-12">
                      <div className=" " id="mypage2">
                        <div className="table-responsive ">
                          <div className="servies-content become_driver last_order thank-you-page">
                            <ReactToPrint content={() => ref.current}>
                              <PrintContextConsumer>
                                {({ handlePrint }) => (
                                  <button onClick={handlePrint} className="btn btn-small" style={{ marginBottom: "14px", background: "#3c50e0", color: "#fff" }}>Print</button>
                                )}
                              </PrintContextConsumer>
                            </ReactToPrint>
                            <div className="table-responsive ">
                              <table ref={ref} id="print_<?php echo xxh; ?>" className="table-bordered table-striped table-hover table product_account" cellPadding={5} cellSpacing={0} border={1} width="100%" style={{ fontFamily: 'arial', margin: 'auto' }}>

                                <thead>
                                  <tr><th colSpan={10}>
                                    <h3 style={{ textAlign: "center" }}>Reward</h3></th>
                                  </tr>
                                  <tr><th colSpan={5} style={{ textAlign: "center", verticalAlign: "middle" }}><img src={logoUrl || logo} height={50} alt="logo" style={{ marginBottom: "4%" }} />
                                  </th>
                                    <th colSpan={5}>
                                      Receipt Username : {name}<br />
                                      Receipt Email: {email}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td colSpan={5}>
                                      <p style={{ float: 'right', fontSize: '17px !important' }}><b>Invoice Amount:<b /></b></p><b><b>
                                      </b></b></td>
                                    <td colSpan={5}>
                                      <p style={{ float: 'right', fontSize: '17px !important' }}><b>{rewardAmount} {currency}</b></p>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div className="modal-footer" style={{ display: 'flex', justifyContent: "space-between" }}>
                    <p style={{ color: "green" }}>
                      {successMessage}
                    </p>
                    <button type="button" className="btn btn-sm" onClick={handleReward} style={{ backgroundColor: '#4e25b8', color: "#fff", padding: "2%", width: "19%" }}>Claim Reward</button>
                  </div>
                </div>

              </>
            </Modal>
            <div
              className={`reward-icon-button ${isAnimating ? "pulse" : ""} ${hasNewReward ? "has-reward" : ""}`}
              onClick={handleRewardClick}
              role="button"
              tabIndex={0}
              aria-label="Claim Reward"
              onKeyDown={(e) => e.key === "Enter" && handleRewardClick()}
            >
              <span className="icon-inner">🎁</span>
              {hasNewReward && <span className="notification-dot"></span>}
            </div>

            {showReward && (
              <div className="reward-overlay" onClick={closeReward}>
                <div className="reward-modal" onClick={(e) => e.stopPropagation()}>
                  {/* <button className="close-modal-button" onClick={closeReward} aria-label="Close">
                    ×
                  </button> */}

                  <div className="reward-content">
                    <div className="reward-header">
                      <div className="reward-stars">
                        <span>✨</span>
                        <span>✨</span>
                        <span>✨</span>
                      </div>
                      <h2>You've Earned Rewards!</h2>
                    </div>

                    <div className="reward-circle">
                      <div className="reward-icon-large">🏆</div>
                      <div className="reward-number" key={rewardAmount}>
                        <span className="plus-sign">+{rewardAmount}</span>
                      </div>
                      <div className="reward-glow"></div>
                      <div className="reward-particles">
                        <div className="particles-inner">
                          {[...Array(12)].map((_, i) => (
                            <span key={i}></span>
                          ))}
                        </div>
                      </div>
                    </div>

                    <p>
                      Amazing! You've earned <strong >{rewardAmount}</strong> points to use towards your next purchase.
                    </p>

                    <button className="claim-button" onClick={claimReward}>
                      <span>Claim Reward</span>
                      <svg viewBox="0 0 16 16" height="16" width="16" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M6.5 3.5l4 4.5-4 4.5"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            )}
          </>
        }

        <div className="container">

          <div className="row">

            <div className="col-md-6 col-sm-6">
              <ul>
                <li className="phone-cll acx_phone_hide">
                  <a className="get_country_code_tel" href={`tel:${phone?.replace(/\s/g, '')}`} style={{ color: "#fff", background: "none" }}>
                    <span className="icon-sp"></span>

                    <span className="number-sp" style={{ color: "#fff" }}>  {phoneicon} {phone}   </span>
                  </a>
                </li>
                <li>
                  <a className="get_country_code_wa" href={`https://wa.me/${whatsapp?.replace(/\s/g, '')}`} target="_blank" rel="noopener noreferrer" style={{ color: "#fff", background: "none" }}>
                    {whatsappicon}<span className="get_wa" style={{ color: "#fff" }}>{whatsapp} </span>
                  </a>
                </li>
                <li />
              </ul>
            </div>
            <div className=" col-md-6 col-sm-6">
              <ul className="member-login">

                <li className="phone-cll acx_phone_hide" style={{ float: "right" }}>
                  {
                    role ? (
                      <a className="get_country_code_tel" onClick={logout} style={{ color: "#fff", background: "none", cursor: "pointer" }}>
                        <span className="icon-sp"></span>
                        <span className="" style={{ color: "#fff" }}>  {regicon} Logout   </span>
                      </a>
                    ) : <Link className="get_country_code_tel" to="register" style={{ color: "#fff", background: "none" }}>

                      <span className="icon-sp"></span>
                      <span className="number-sp" style={{ color: "#fff" }}>  {regicon} Register   </span>
                    </Link>
                  }

                </li>
                <li className="phone-cll acx_phone_hide" style={{ float: "right" }}>


                  {
                    role ? (
                      <Link className="get_country_code_tel" to="my-account/dashboard" style={{ color: "#fff", background: "none" }}>
                        <span className="icon-sp"></span>
                        <span className="number-sp" style={{ color: "#fff" }}>  {usericon} My Account </span>
                      </Link>
                    ) : (
                      <Link className="get_country_code_tel" to="login" style={{ color: "#fff", background: "none" }}>
                        <span className="icon-sp"></span>
                        <span className="number-sp" style={{ color: "#fff", background: "none" }}>  {usericon} Login </span>
                      </Link>
                    )
                  }

                </li>

              </ul>
            </div>
          </div>
        </div>
      </div>
      {
        currentUrl.includes("my-account") ? (
          <></>
        ) : (
          <div>
            <nav className="navbar navbar-expand-lg navbar-light bg-light">
              <div className="container-fluid">
                <Link className="offset-1 navbar-brand headerlogo" to="/">
                  <img src={logoUrl} alt={selectedCountry?.countryName || 'Logo'} style={{ width: "100%" }} />
                </Link>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                  <span className="navbar-toggler-icon"></span>
                </button>
                <div className="offset-1 collapse navbar-collapse" id="navbarNav">
                  <ul className="navbar-nav">
                    <>
                      <li className="nav-item">
                        <NavLink activeclassname="active" exact to={`${countryPrefix}/`}>HOME</NavLink>
                        {/* <Link className="nav-link active"  aria-current="page" exact  to="/">HOME  </Link> */}
                      </li>
                      <li className="nav-item">
                        <NavLink exact to={`${countryPrefix}/track`}>TRACK</NavLink>
                        {/* <Link className="nav-link" exact  to="/track">TRACK</Link> */}
                      </li>

                      {/* <li className="nav-item">
                        <NavLink exact to="/smart-send">SMART SEND</NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink exact to="/your-business">YOUR BUSINESS</NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink exact to="/help">HELP</NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink exact to="/become-a-partner">PARTNERS</NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink exact to="/parcels-on-demand">HOW IT WORKS</NavLink>
                      </li>
                      <li className="nav-item">
                        <a href="https://www.tymexlogistics.com/" target="_blank">LOGISTICS</a>
                      </li>
                      <li className="nav-item">
                        <NavLink exact to="/client-zone">CLIENT ZONE</NavLink>
                      </li> */}
                    </>
                  </ul>
                </div>
              </div>
            </nav>
          </div>
        )
      }

      {
        message && message != '' ? (
          <>
            {
              typeban && typeban == 'red' ? (
                <>
                  <div style={{ backgroundColor: 'red' }}>
                    <div className="container">
                      <div className="row">
                        <div className="" style={{ textAlign: 'center', color: '#fff', padding: '10px', fontWeight: '600', letterSpacing: '2px' }}>{message}</div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div style={{ backgroundColor: '#3c50e0' }}>
                    <div className="container">
                      <div className="row">
                        <div className="" style={{ textAlign: 'center', color: '#fff', padding: '10px', fontWeight: '600', letterSpacing: '2px' }}>{message}</div>
                      </div>
                    </div>
                  </div>
                </>
              )
            }

          </>
        ) : null
      }
    </>
  )
}
